module.exports = __webpack_public_path__ + "static/media/16.31a0f1c3.jpg";